(() => {
  const root = document.querySelector('[data-market-strategy]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const frameArea = root.querySelector('.ms-pitch-frame');
  const poster = root.querySelector('.ms-pitch-poster');
  let generation = 0;
  root.querySelector('[data-load-pitch]').addEventListener('click', async () => {
    const request = ++generation;
    const status = root.querySelector('.ms-frame-loading');
    status.textContent = 'Loading the interactive pitch…';
    status.hidden = false;
    poster.hidden = true;
    frameArea.hidden = false;
    root.querySelector('[data-close-pitch]').focus({preventScroll: true});
    try {
      // Reuse the source page's current configuration and component. No cloned
      // product catalog or divergent campaign settings are maintained here.
      const response = await fetch('/pages/eugene-ext-sponsorship-preview', {signal: AbortSignal.timeout(20000)});
      if (!response.ok) throw new Error('Pitch unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const config = document.querySelector('gameday-ext-configurator [data-ext-catalog]');
      const module = document.querySelector('script[type="module"][src*="gameday-ext-configurator"]');
      if (!config || !module) throw new Error('Pitch configuration unavailable');
      const source = new URL(module.getAttribute('src'), location.origin);
      if (source.origin !== location.origin && source.hostname !== 'cdn.shopify.com') throw new Error('Unexpected module origin');
      const data = JSON.parse(config.textContent);
      if (data.sponsorship !== true || data.viewerOnly !== true) throw new Error('Expected campaign preview');
      await import(source.href);
      if (request !== generation) return;
      const component = window.document.createElement('gameday-ext-configurator');
      component.append(window.document.importNode(config, true));
      root.querySelector('[data-pitch-mount]').replaceChildren(component);
      // The original uses a full-window height. Constrain only its host when
      // displayed as part of this page; its controls and scene remain intact.
      const fit = window.document.createElement('style');
      fit.textContent = ':host([viewer-only]){height:100%!important;min-height:0!important}:host([viewer-only]) main > .experience > #stage{height:clamp(520px,85vh,720px);min-height:0}';
      component.shadowRoot?.append(fit);
      status.hidden = true;
    } catch {
      if (request !== generation) return;
      status.textContent = 'The embedded pitch could not load. Open the full-screen experience above, or close and try again.';
    }
  });
  root.querySelector('[data-close-pitch]').addEventListener('click', () => {
    generation++;
    root.querySelector('[data-pitch-mount]').replaceChildren();
    frameArea.hidden = true;
    poster.hidden = false;
    root.querySelector('[data-load-pitch]').focus({preventScroll: true});
  });
  root.querySelectorAll('[data-inquiry]').forEach(link => link.addEventListener('click', () => {
    root.querySelector('#MarketTopic').value = link.dataset.inquiry;
  }));
  root.querySelectorAll('[data-share]').forEach(button => button.addEventListener('click', async () => {
    const url = new URL('/pages/market-sales-strategy', location.origin);
    url.hash = button.dataset.share;
    try {
      await navigator.clipboard.writeText(url.href);
      button.textContent = 'Link copied';
      root.querySelector('[data-share-status]').textContent = 'Pitch link copied to clipboard.';
      setTimeout(() => { button.textContent = 'Copy pitch link'; root.querySelector('[data-share-status]').textContent = ''; }, 3500);
    } catch {
      location.hash = button.dataset.share;
      root.querySelector('[data-share-status]').textContent = 'This pitch is now in your address bar. Copy the address to share it.';
    }
  }));
})();
